import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { IShoppingSubscription } from 'v2/interfaces/shopping';
import shoppingSubscriptionService from 'v2/services/shopping/subscription';

function useSubscription(
  subscriptionId: number,
  options?: Omit<UseQueryOptions<IShoppingSubscription>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: ['subscription', subscriptionId],
    queryFn: ({ queryKey }) => {
      const [, subscriptionId] = queryKey;
      return shoppingSubscriptionService.getSubscription(subscriptionId as number).toPromise();
    },
    ...options
  });
}

export { useSubscription };
